<template>
  <div
    @click="handleClick"
    class="delivery-spot"
    ref="deliverySpotBlock"
    :class="{ 'delivery-spot--selected': isSelected, 'delivery-spot--disabled': isWeightDisable }"
  >
    <div class="delivery-spot__wrapper" v-if="mailName !== 'chooseStore' && !isProduct">
      <p class="delivery-spot__info--address">{{ spot.description }}</p>
      <p class="delivery-spot__distance" v-if="distanceToUser && isCheckout">
        {{ `~${distanceToUser} ${$t('from_location')}` }}
      </p>
      <div class="delivery-spot__info" v-if="mailName === 'novaPoshtaWarehouse' && spot.isActive">
        <p class="delivery-spot__schedule">{{ $t('workdays') }} {{ schedule.Monday }}</p>
        <p class="delivery-spot__schedule">{{ $t('saturday') }} {{ schedule.Saturday }}</p>
        <p class="delivery-spot__schedule">{{ $t('sunday') }} {{ schedule.Sunday }}</p>
      </div>
      <div class="delivery-spot__info" v-if="mailName === 'pickupDPDInternational' && spot.isActive">
        <p class="delivery-spot__schedule" v-html="schedule.replaceAll(', ', '<br>')"></p>
      </div>
      <div
        class="delivery-spot__info delivery-spot__info--warehouse"
        :class="{ 'delivery-spot__info--not-checkout': !isCheckout }"
        v-if="mailName === 'pickup' || mailName === 'pickupInternational'"
      >
        <p class="delivery-spot__schedule" v-html="schedule"></p>
        <p class="delivery-spot__phone" v-html="spot.phone"></p>
        <p
          v-if="(spot.cartStatus || spot.cartStatus === $constants.CART_STATUSES.NOT_AVAILABLE) && isCheckout"
          class="delivery-spot__status"
          :class="{
            'delivery-spot__status--in-stock': spot.cartStatus === $constants.CART_STATUSES.TODAY,
            'delivery-spot__status--will-be-in-stock': spot.cartStatus === $constants.CART_STATUSES.NEXT_DAYS,
            'delivery-spot__status--not-in-stock': spot.cartStatus === $constants.CART_STATUSES.NOT_AVAILABLE,
            'delivery-spot__status--pre-order': spot.cartStatus === $constants.CART_STATUSES.PRE_ORDER
          }"
        >
          {{ spotCartStatus }}
        </p>
      </div>
      <div class="delivery-spot__info delivery-spot__info--ukrpochta" v-if="mailName === 'ukrposhta'">
        <p class="delivery-spot__phone">{{ spot.phone }}</p>
      </div>
      <Button
        class="vue-button--delivery-spot"
        v-if="!(spot.isSuccessful || isWeightDisable || spot.cartStatus === $constants.CART_STATUSES.NOT_AVAILABLE) && isCheckout"
        @click.native="handleClick(true)"
        :type="isSelected ? '' : 'plain'"
        size="small"
      >{{ $t('choose') }}</Button
      >
    </div>
    <div class="delivery-spot__wrapper" v-else-if="isProduct || mailName === 'chooseStore'">
      <div class="reserve-info">
        <h2 class="reserve-info__title">{{ spot.description }}</h2>
        <p class="reserve-info__distance" v-if="distanceToUser">
          {{ `~${distanceToUser} ${$t('from_location')}` }}
        </p>
        <div class="reserve-info__shedule-wrap">
          <span class="reserve-info__shedule" v-html="schedule"></span>
          <span class="reserve-info__phone">{{ spot.phone | PhoneFormatter }}</span>
        </div>
        <span v-if="!withoutAddToCart" class="reserve-info__quantity" :class="{ 'reserve-info__quantity--in-stock': spot.quantity > 0 }">{{
          productQuantity
        }}</span>
        <span class="reserve-info__delivery-text">{{ spotStatus }}</span>
        <div v-if="mailName === 'chooseStore'">
          <button @click.stop="chooseStore(spot)" class="set-store__btn" :class="{ 'set-store__btn--disable': !spot.quantity }">
            <span v-if="!spot.quantity">{{ $t('delivery-store-balance.not-in-stock') }}</span>
            <span v-else>{{ $t('delivery-store-balance.choose-store') }}</span>
          </button>
        </div>
        <div v-else-if="spot.status === $constants.CART_STATUSES.NOT_AVAILABLE || (spot.status === $constants.CART_STATUSES.PRE_ORDER && spot.quantity < 1)" class="reserve-info__btns-wrap">
          <WaitListBtn
            :in-wait-list-status="spot.isInWaitList"
            :title-analytics="titleAnalytics"
            :product-id="computedProductId"
            :store-id="spot.storeId"
            is-small-card
            is-map-modal
            class="wait-list--map-modal"
          />
        </div>
        <!--        <div v-else-if="spot.status === $constants.CART_STATUSES.PRE_ORDER" class="reserve-info__btns-wrap">-->
        <!--          <button @click.stop="reserve('pre-order')" class="reserve-info__btn reserve-info__btn&#45;&#45;inverse">{{ $t('pre_order') }}</button>-->
        <!--        </div>-->
        <div v-else class="reserve-info__btns-wrap">
          <button @click.stop="reserve('reserve')" class="reserve-info__btn">{{ $t('reserve_to_reserve') }}</button>
          <button @click.stop="buy" class="reserve-info__btn reserve-info__btn--inverse">
            {{ $t('reserve_to_cart') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Button from '@/components/inputs/Button'
import WaitListBtn from '@/components/product/product-page/WaitListBtn'
import PhoneFormatter from '@/filters/PhoneFormatter'
import { getDistanceBetweenUserAndSpot } from '@/helpers/getDistanceBetweenUserAndSpot'
import { GoogleEnhancedEcommerce, GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'DeliverySpot',
  components: {
    Button,
    WaitListBtn
  },
  filters: {
    PhoneFormatter
  },
  props: {
    withoutAddToCart: {
      type: Boolean
    },
    spot: {
      type: Object
    },
    mailName: {
      type: String,
      required: true
    },
    buyOnStore: {
      type: [Number, String]
    },
    productId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      isCheckout: this.$constants.IS_CHECKOUT() && !this.$constants.IS_CHECKOUT_SUCCESS(),
      isProduct: this.$constants.IS_PRODUCT,
      isCheckoutSuccess: this.$constants.IS_CHECKOUT_SUCCESS()
    }
  },
  computed: {
    ...mapGetters(['cartModalName']),
    ...mapState({
      formData: state => state.checkout.formData,
      distanceToSelectedSpot: state => state.deliveryForm.distanceToSelectedSpot,
      selectedSpot: state => state.map.selectedSpot,
      productIdProductPage: state => state.productInfo.productInfo.productId,
      code: state => state.productInfo.productInfo.code,
      price: state => state.productInfo.productInfo.price,
      titleAnalytics: state => state.productInfo.productInfo.titleAnalytics,
      isNovelty: state => state.productInfo.productInfo.isNovelty,
      inStock: state => state.productInfo.productInfo.inStock
    }),
    computedProductId () {
      return this.productId || this.productIdProductPage
    },
    schedule () {
      // Если выбран метод доставки в отделение НП парсит JSON с инфой по графику работы
      if (this.mailName === 'novaPoshtaWarehouse' && this.isCheckoutSuccess) {
        return this.spot.schedule
      }
      return this.mailName === 'novaPoshtaWarehouse' ? JSON.parse(this.spot.schedule) : this.spot.schedule
    },
    isSelected () {
      if (this.spot.isSuccessful) return true
      if (this.selectedSpot) {
        return (
          this.selectedSpot.title === this.spot.description ||
          this.selectedSpot.description === this.spot.description
        )
      }
      return false
    },
    isWeightDisable () {
      // Делает отдел неактивным если превышен макимальный допустимый вес заказа
      return this.spot.isAvailable && this.spot.isAvailable === '0'
    },
    notThankyouPage () {
      return this.$route.name !== 'checkout-success'
    },
    distanceToUser () {
      return getDistanceBetweenUserAndSpot(this.spot)
    },
    productQuantity () {
      let quantity

      if (this.spot.quantity || this.spot.quantity === 0) {
        if (this.spot.quantity > 3) {
          quantity = this.$t('reserve_more_then')
        } else if (this.spot.quantity > 0 && this.spot.quantity <= 3) {
          quantity = this.$t('reserve_in_stock') + ' ' + this.spot.quantity + ' шт'
        // } else if (this.spot.status === this.$constants.CART_STATUSES.PRE_ORDER) {
        //   quantity = this.$t('reserve_pre_order')
        } else {
          quantity = this.$t('reserve_not_in_stock')
        }
      }

      return quantity
    },
    spotCartStatus () {
      let status

      if (this.spot.cartStatus || this.spot.cartStatus === this.$constants.CART_STATUSES.NOT_AVAILABLE) {
        if (this.spot.cartStatus === this.$constants.CART_STATUSES.NOT_AVAILABLE) {
          status = this.$t('reserve_order_not_available')
        } else if (this.spot.cartStatus === this.$constants.CART_STATUSES.TODAY) {
          status = this.$t('reserve_now_in_stock')
        } else if (this.spot.cartStatus === this.$constants.CART_STATUSES.NEXT_DAYS) {
          status = this.$t('reserve_will_be_in_stock')
        } else if (this.spot.cartStatus === this.$constants.CART_STATUSES.PRE_ORDER && this.spot.quantity > 0) {
          status = this.$t('reserve_now_in_stock')
        } else {
          status = ''
        }
      }

      return status
    },
    spotStatus () {
      let status

      if (this.spot.status || this.spot.status === this.$constants.CART_STATUSES.NOT_AVAILABLE) {
        if (this.spot.status === this.$constants.CART_STATUSES.NOT_AVAILABLE) {
          status = this.$t('reserve_order_not_available')
        } else if (this.spot.status === this.$constants.CART_STATUSES.TODAY) {
          status = this.$t('reserve_now_in_stock')
        } else if (this.spot.status === this.$constants.CART_STATUSES.NEXT_DAYS) {
          status = this.$t('reserve_will_be_in_stock')
        } else if (this.spot.status === this.$constants.CART_STATUSES.PRE_ORDER && this.spot.quantity > 0) {
          status = this.$t('reserve_now_in_stock')
        } else {
          status = ''
        }
      }

      return status
    },
    computedCode () {
      return this.code
    }
  },
  methods: {
    ...mapActions(['SET_FORM_DATA', 'FETCH_PAYMENT_TYPE', 'SET_STORE']),
    chooseStore (spot) {
      this.SET_STORE(spot).then(() => {
        this.$modal.hide('map-modal')
        if (this.computedProductId) {
          this.buy()
        }
      })
    },
    handleClick (hideModal) {
      // Закидывает выбранный отдел в стор, записывает его в local storage и вызывает емит для перемещения гугл карты к выбранному отделу
      const { description: title, latitude, longitude } = this.spot

      if (latitude || longitude) {
        this.$emit('selectSpot', { ...this.spot, title, isWeightDisable: this.isWeightDisable })
      }
      if (hideModal === true) this.$modal.hide('map-modal')
    },
    reserve (type = 'reserve') {
      this.$modal.hide('map-modal')
      this.$modal.show('quick-order-modal', {
        quantity: this.spot.quantity,
        storeId: this.spot.storeId,
        link:
          this.spot.googleLink ||
          `//maps.google.com/maps?saddr=Current+Location&daddr=${this.spot.latitude},${this.spot.longitude}`,
        title: this.spot.description,
        status: this.spot.status,
        staticMapLink: this.spot.staticMapLink,
        type: type
      })
    },
    buy () {
      if (!this.withoutAddToCart) {
        this.$store
          .dispatch('ADD_PRODUCT_TO_CART', {
            productId: this.computedProductId,
            storeId: this.spot.storeId
          })
          .then(
            response => {
              this.$modal.hide('map-modal')
              this.$modal.show(this.cartModalName)

              this.$store.dispatch('CHANGE_CART_RTB_HOUSE_CODE_FLAG', true)
              const currentProduct = response.products.find(product => product.id === this.computedProductId)
              if (GoogleEnhancedEcommerce.isEnabled) {
                GoogleEnhancedEcommerce.addToCart({
                  value: +GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0]).price * parseInt(GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0]).quantity),
                  items: [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0])]
                })
              } else {
                // window.gtag('event', 'add_to_cart', {
                //   'ecomm_pagetype': window.ecomm_pagetype || 'other',
                //   'ecomm_prodid': this.code,
                //   'ecomm_totalvalue': this.price
                // })
                GoogleTagManagerService.pushToAnalytics({
                  analyticsData: currentProduct.analytics_data,
                  eventName: 'add_to_cart'
                })
              }
              // GoogleTagManagerService.addToCartEvent({
              //   analyticsData: [
              //     {
              //       'name': this.titleAnalytics,
              //       'id': `${this.code}`,
              //       'price': `${this.price}`,
              //       'category': `${currentProduct.category_parent_id}/${currentProduct.category_id}`
              //     }
              //   ],
              //   params: {
              //     'event': 'gtm-ee-event-add-to-cart',
              //     'gtm-ee-event-action': 'Adding a Product to a Shopping Cart'
              //   }
              // })

              window.fbq('track', 'AddToCart', {
                content_name: this.titleAnalytics,
                content_ids: [this.code],
                content_type: 'product',
                value: this.price,
                currency: window.config?.currency?.currency_code
              })
            },
            () => {
              this.$modal.show('warning-modal', {
                text: this.$t('product_ends_warning_text'),
                title: this.$t('product_ends_warning_title')
              })
            }
          )
      }
    }
  },
  watch: {
    buyOnStore (val) {
      if (val && +this.spot.storeId === +val) {
        this.buy()
      }
    }
  }
}
</script>

<style lang="sass">
.set-store__btn
  background-color: $main-color
  color: #fff
  font-size: 14px
  line-height: 18px
  padding: 10px 20px
  border: 1px solid #ff2f00
  color: #fff
  border-radius: 3px
  transition: .4s
  &--disable
    pointer-events: none
    background-color: #f0f0f0
    color: #333
    border-color: transparent
  &:hover
    background-color: #fff
    color: #333

</style>
<style scoped lang="sass">
.set-store__btn
  margin-top: 10px
.delivery-spot
  padding: 20px
  border-bottom: 1px solid $nd-border-color
  position: relative
  cursor: pointer
  font-weight: 400 //Rubik 300
  &__wrapper
    min-height: 50px

  &--selected
    background-color: #f6f6f6

    .delivery-spot__btn
      background-color: $main-color
      color: #fff

    .delivery-spot__info--address
      text-decoration: none
      color: $text-color

  &--disabled
    background-color: rgba(0, 0, 0, 0.1)
    cursor: default
    border-bottom-color: #dbdbdb

.vue-button--delivery-spot
  position: absolute
  font-size: 14px
  bottom: 20px
  right: 10px

.delivery-spot__info
  &--address
    margin-top: 0
    color: #3E77AA
    font-size: 14px
    text-decoration: underline
    margin-bottom: 20px

  &--warehouse:not(&--not-checkout)
    width: 50%

.delivery-spot__schedule, .delivery-spot__phone
  color: $placeholder-color
  font-size: 14px
  line-height: 16px
  margin: 0

.delivery-spot__phone
  margin-top: 10px

.delivery-spot__info--ukrpochta
  height: 30px
  width: 40%

.delivery-spot__distance
  font-size: 14px
  color: $placeholder-color
  line-height: 17px
  display: block
  margin: -5px 0 10px
  max-width: calc(100% - 137px)

.delivery-spot__status
  font-size: 14px

  &--not-in-stock
    color: $placeholder-color

  &--in-stock
    color: $nd-green-text-color

  &--will-be-in-stock
    color: $main-color
</style>
